import { haystackMatchesCommaSearch } from "@/lib/manufacturing/commaDelimitedSearch";
import type { MfgRecipeSummary } from "@/lib/manufacturing/types";

export type ModelsActiveFilter = "active" | "inactive" | "all";

export function filterManufacturingModels(
  recipes: readonly MfgRecipeSummary[],
  opts: {
    search: string;
    activeFilter: ModelsActiveFilter;
    needsReviewOnly?: boolean;
    /** Empty string = all groups; `"__ungrouped__"` = no group; else group id. */
    recipeGroupId?: string;
  },
): MfgRecipeSummary[] {
  return recipes.filter((r) => {
    if (opts.activeFilter === "active" && !r.is_active) return false;
    if (opts.activeFilter === "inactive" && r.is_active) return false;
    if (opts.needsReviewOnly && !r.needs_review) return false;
    if (opts.recipeGroupId === "__ungrouped__") {
      if (r.recipe_group_id) return false;
    } else if (opts.recipeGroupId) {
      if (r.recipe_group_id !== opts.recipeGroupId) return false;
    }
    const hay = [r.code, r.name, r.kind, ...(Array.isArray(r.tags) ? r.tags : [])].join(" ");
    return haystackMatchesCommaSearch(hay, opts.search);
  });
}
